import type { TranslationSchema } from './en'

export const ru: TranslationSchema = {
  game: {
    title: 'Path of Praxis',
    subtitle: 'Создай теорию своего инкрементального auto-battler',
    deathTitle: 'Вы погибли',
    deathSubtitle: 'Вы получили следующий опыт и мастерство, чтобы сделать следующее возрождение сильнее:',
    deathRebirth: 'Возродиться',
    actionSelectTitle: 'Действия',
    triggersTitle: 'Триггеры действий',
    triggerAutoAction: 'Авто-атака',
    actionPickerTitle: 'Выбрать действие',
    legendDamage: 'Урон',
    legendSpeed: 'Скорость',
    legendRange: 'Дальность',
    legendArea: 'Область',
    legendMana: 'Мана',
    targetingTitle: 'Приоритет цели',
    targetNearest: 'Ближайший',
    targetWeakest: 'Слабейший',
    targetStrongest: 'Сильнейший',
    targetRandom: 'Случайный',
    targetNearestDesc: 'Атаковать ближайшего врага',
    targetWeakestDesc: 'Фокус на низком здоровье',
    targetStrongestDesc: 'Фокус на высоком здоровье',
    targetRandomDesc: 'Выбрать случайную цель',
    backToMenu: 'Вернуться в меню',
    dieRebirth: 'Умереть и возродиться',
    freeRebirth: 'Свободное возрождение',
    dieConfirmTitle: 'Умереть и возродиться?',
    dieConfirmBody: 'Текущий забег завершится, и ваши мастерства будут применены. Продолжить?',
    dieConfirmYes: 'Умереть и возродиться',
    battleConfig: 'Конфигурация боя',
    masteries: 'Мастерства',
    ascentBtnLabel: 'Вознесение',
    enemyLevelLabel: 'Уровень врага',
    pauseLabel: 'Пауза',
    playLabel: 'Продолжить',
    x2SpeedRemaining: 'Осталось времени ×2',
    enemyLevelDown: 'Уменьшить уровень врага',
    enemyLevelUp: 'Увеличить уровень врага',
    autoAdvanceTitle: 'Авто-повышение уровня врага при разблокировке',
    autoLevelAriaLabel: 'Авто-уровень врагов',
    autoLevelText: 'Авто',
    ascendBtn: 'Вознестись в новую вселенную',
    masteryGains: 'Прирост мастерства',
    actionTriggerTitle: 'Триггер действия',
    selectActionTrigger: 'Выбрать триггер действия',
    slotInUse: 'Уже используется другим триггером',
    triggerTime: 'Временной триггер',
    triggerTimeDesc: 'Срабатывает каждые 2 секунды. Более быстрые действия наносят больше урона, более медленные — меньше.',
    triggerCrit: 'Триггер крита',
    triggerCritDesc: 'Срабатывает при критическом ударе авто-атаки. Базовый урон в 10 раз меньше, сбалансирован скоростью.',
    triggerCritLock: 'Убить босса критическим ударом',
    triggerAffliction: 'Триггер недуга',
    triggerAfflictionDesc: 'Срабатывает каждые 10 применённых недугов. Урон сбалансирован скоростью.',
    triggerAfflictionLock: 'Убить босса уроном от недугов',
    triggerMana: 'Триггер маны',
    triggerManaDesc: 'Срабатывает за каждые 100 маны, потраченной вашими действиями. Урон сбалансирован скоростью.',
    dpsDoubleAction: 'Двойное действие',
    dpsBonusTarget: 'Бонусная цель',
    dpsExtraProjectile: 'Дополнительный снаряд',
    dpsSplitCast: 'Разделённое заклинание',
    dpsChainJump: 'Цепной прыжок',
    dpsTremor: 'Содрогание',
    dpsAfflictionBurn: 'Поджог',
    dpsAfflictionBleed: 'Кровотечение',
    dpsAfflictionGroundFire: 'Горящая земля',
    dpsAfflictionPoison: 'Яд',
    dpsSplash: 'Всплеск',
    dpsTakenHits: 'Полученный урон (удары)',
    dpsTakenAfflictions: 'Полученный урон (недуги)',
    dpsAvgHitTaken: 'Средний полученный удар',
    dpsMaxHitTaken: 'Крупнейший полученный удар',
    selectAnAction: 'Выбрать действие',
    critLabel: 'Крит',
  },
  mastery: {
    title: 'Мастерства',
    resetTitle: 'Сбросить {name}?',
    confirmCancel: 'Отмена',
    confirmReset: 'Сбросить',
    resetDescLoseLevel: 'Все назначенные узлы будут очищены, и вы потеряете 1 уровень в этом мастерстве. Вложенные очки возвращаются.',
    resetDescNoLoseLevel: 'Все назначенные узлы будут очищены. Бесплатные и вложенные очки мастерства будут возвращены.',
    nodeSmall: 'Малый узел',
    nodeStrong: 'Сильный узел',
    nodeMajor: 'Крупный узел',
    nodeKey: 'Ключевой узел',
    nodeAssigned: 'Назначен',
    nodeAssignPt: 'Назначить ({cost} оч.)',
    nodeAssignPts: 'Назначить ({cost} оч.)',
    nodeNeedPt: 'Нужно {cost} очко мастерства (есть {available})',
    nodeNeedPts: 'Нужно {cost} очка мастерства (есть {available})',
    nodeKeyChosen: 'Другой ключевой узел уже выбран',
    nodeNotImpl: 'Ещё не реализовано',
    nodeNotAvail: 'Узел недоступен',
    resetBtn: 'Сбросить (−1 уровень)',
    dumpBtn: 'Вложить очко',
    dumpTooltip: 'Клик: вложить 1 очко · Ctrl/Cmd+клик: вложить все',
    dumpActivePt: 'Вложение: {dumped} оч. → +{bonus}% больше {label}',
    dumpActivePts: 'Вложение: {dumped} оч. → +{bonus}% больше {label}',
    dumpLabel: 'Вкладывать очки для +{rate}% больше {label} за очко',
    pointsPt: 'У вас {total} / {earned} очко мастерства для назначения{free}',
    pointsPts: 'У вас {total} / {earned} очков мастерства для назначения{free}',
    pointsFree: ' ({n} бесплатно)',
    ctrlClickHint: 'Совет: Ctrl/Cmd + клик на узел для назначения всех доступных очков сразу.',
    savePlan: 'Сохранить план',
    loadPlan: 'Загрузить план',
    assignAll: 'Назначить всё',
    assignAllDump: 'Сбросить лишние очки',
    assignAllDumpTooltip: 'После выполнения плана «Назначить всё» сбросит оставшиеся очки в конверсию',
    slot: 'Слот {n}',
    slotEmpty: '(пусто)',
    copyClipboard: 'Копировать в буфер',
    importCode: 'Импорт',
    planActive: '{code}',
    planInvalid: 'Неверный код сборки',
    assignAllNone: 'Нет загруженного плана',
    saveNoHistory: 'Порядок назначения ваших текущих узлов не был записан. Сохранение планов станет доступно после следующего Вознесения.',
    pendingGainsNote: 'Прогресс, показанный зелёным, будет получен только после смерти и возрождения',
  },
  ascent: {
    title: 'Вознесение',
    ascentCount: 'Количество вознесений: {n}',
    nextAscent: 'Следующее вознесение: уровень врага {n}',
    unlockedAt: 'Разблокировано на',
    universePoints: 'Очки вселенной',
    available: '({n} доступно)',
    removePoint: 'Убрать очко',
    addPoint: 'Добавить очко',
    threshold1: 'Критический удар и его мастерство',
    threshold2: 'Дерево чемпионов и боссов в мастерстве врагов',
    threshold3: '+1 слот триггера действия',
    threshold4: '+1 бесплатное очко мастерства за вознесение для каждого мастерства',
    threshold5: 'Артефакты — модификаторы риск/награда',
    threshold6: '+1 слот триггера действия',
    threshold7: 'Каждое вознесение даёт 3 очка вселенной вместо 2',
    threshold8: 'На 20% больше врагов и на 20% больше опыта уровня врага',
    threshold9: 'Экипируйте второй артефакт и носите до 30 в сумке',
    artifactsBtn: 'Артефакты',
    upSlotA: 'Скорость мульти-действия увеличена на 10%',
    upSlotB: '+1% базового шанса крита действия',
    upSlotC: '+7% к урону',
    upSlotD: '+4% к скорости действия',
  },
  transcend: {
    btn: 'Трансценденция',
    pickerTitle: 'Выберите реликвию',
    pickerHint: 'Трансценденция сбрасывает всё — включая вознесения, очки вселенной и неэкипированные артефакты. Экипированные артефакты и реликвии сохраняются. Выберите реликвию, чтобы трансцендировать.',
    confirmTitle: 'Трансцендировать?',
    confirmBody: 'Всё сбрасывается — включая вознесения, очки вселенной и неэкипированные артефакты. Экипированные артефакты и реликвии сохраняются.',
    relicFreeRebirth: 'Эхо возрождения',
    relicFreeRebirthDesc: 'Раз за возрождение получите неполученный прогресс мастерства без смерти.',
    relicMultiAscend: 'Разрушитель цепей',
    relicMultiAscendDesc: 'Вознесение может давать несколько вознесений сразу — до вашего максимального уровня врага −5.',
    relicExtraTrigger: 'Третья рука',
    relicExtraTriggerDesc: 'Постоянно открывает дополнительный слот триггера действия.',
    relicOnslaught: 'Натиск',
    relicOnslaughtDesc: 'На 30% больше врагов, на 10% больше всего опыта, на 10% больше всего урона.',
    powerLabel: 'Трансценденция: {n}',
    powerSummary: '+{xp}% опыта · +{dmg}% урона · +{life}% макс. жизни',
    relicsLabel: 'Реликвии',
    ascendPlus: '{label} (+{n})',
  },
  artifacts: {
    title: 'Артефакты',
    countLabel: '{n}/{max} артефактов',
    equippedLabel: 'Экипировано: {used}/{max}',
    full: 'Инвентарь полон — сбросьте артефакт, чтобы получать новые от боссов',
    equip: 'Экипировать',
    unequip: 'Снять',
    bag: 'Сумка',
    drop: 'Сбросить',
    deleteBtn: 'Удалить',
    deleteConfirmTitle: 'Удалить артефакт?',
    deleteConfirmBody: 'Этот артефакт будет навсегда утерян.',
    deleteConfirmBtn: 'Удалить',
    lockedHint: 'Слоты заняты — сначала снимите другой артефакт',
    sourceFire: 'огня',
    sourceLightning: 'молнии',
    sourcePhysical: 'физического',
    sourceCold: 'холода',
    sourceRot: 'гнили',
    posSourceMoreDamage: '+{v}% урона от {source}',
    posSourceActionSpeed: '+{v}% скорости действия {source}',
    posSourceAffliction: '+{v}% эффекта affliction {source}',
    posGlobalActionSpeed: '+{v}% скорости действия',
    posGlobalMoreDamage: '+{v}% урона',
    posDoubleDamageChance: '+{v}% шанс двойного урона',
    posDoubleActionChance: '+{v}% шанс двойного действия',
    posRangeAndArea: '+{v}% дальности и области',
    negDamageTaken: '+{v}% получаемого урона',
    negAllResistances: '-{v}% ко всем сопротивлениям',
    negLessMoveSpeed: '-{v}% скорости движения',
    negLessActionSpeed: '-{v}% скорости действия',
    negLessRangeAndArea: '-{v}% дальности и области',
    weightLight: 'Лёгкий артефакт',
    weightMedium: 'Средний артефакт',
    weightHeavy: 'Тяжёлый артефакт',
    scrapsLabel: 'Обломки: {n}',
    upgradeBtn: 'Улучшить {scraps}/{cost}',
    upgradeResultTitle: 'Артефакт улучшен',
    upgradeMaxedTitle: 'Максимальное улучшение',
    upgradeMaxedBody: 'Каждая строка этого артефакта уже на максимуме — его нельзя улучшить дальше.',
    upgradeRemovedLabel: 'Плохая строка удалена:',
    autoDiscardLabel: 'Автоматически отбрасывать артефакты по качеству:',
    autoDiscardNever: 'никогда не отбрасывать',
    autoDiscardAll: 'отбрасывать все',
    autoDiscardBelow: '<{v}%',
    autoDiscardDown: 'Понизить порог качества автоотбрасывания',
    autoDiscardUp: 'Повысить порог качества автоотбрасывания',
    autoDiscardWeightLabel: 'или вес:',
    autoDiscardWeightAll: 'хранить все размеры',
    autoDiscardWeightLight: 'отбрасывать лёгкие',
    autoDiscardWeightMedium: 'отбрасывать средние и ниже',
    autoDiscardWeightDown: 'Понизить порог веса автоотбрасывания',
    autoDiscardWeightUp: 'Повысить порог веса автоотбрасывания',
  },
  rune: {
    addToSlot: 'Добавить руну {type} в слот {n}',
    clickToChange: '{label} — нажмите, чтобы изменить',
    addRune: '+ Добавить руну',
    remove: 'Удалить «{label}»',
    runesTitle: 'Руны: {action}',
    runesAriaLabel: 'Руны',
    slotMinor: 'Малый',
    slotMajor: 'Крупный',
    slotKey: 'Ключевой',
    slotSource: 'Источник',
    levelHint: 'Действие ур. {level} — {unlocked}/7 слотов открыто — +{bonus}% опыта',
    selectTitle: 'Руна {type} — Слот {n}',
  },
  menu: {
    continue: 'Продолжить',
    characters: 'Персонажи',
    about: 'О игре',
    nav: 'Главное меню',
  },
  about: {
    title: 'О Path of Praxis',
    body: 'Инкрементальный auto-battler от Aractis, вдохновлённый экшен-RPG, многоуровневыми инкрементальными играми с системой престижа и системами вознаграждений на основе использования. Эта ранняя (бета) игра стремится обеспечить богатый опыт создания теорий с механикой полу-idle игры. Пожалуйста, оставляйте отчёты, отзывы и запросы в Discord, ссылка на который указана в настройках. Загляните в список TODO ниже!',
    creditsTitle: 'Авторы',
    creditsAlpha: 'Спасибо N4pkin за мотивацию и альфа-тестирование.',
    creditsKenneyUi: 'Панели и кнопки UI: **Kenney RPG UI Pack Extension** (CC0).',
    creditsKenneyDungeon: 'Плитки карты и препятствия: **Kenney Tiny Dungeon** (CC0).',
    creditsLucide: 'Иконки: **Lucide** (лицензия ISC).',
    creditsFonts: 'Шрифты: **Cinzel** и **Crimson Pro** через Google Fonts (SIL OFL).',
    creditsClaude: 'Разработано с помощью **Claude** (Anthropic).',
    releaseNotes: 'Примечания к выпуску',
    releaseNotesTitle: 'Примечания к выпуску',
    todo: 'TODO',
    todoTitle: 'TODO',
    privacy: 'Конфиденциальность',
    privacyTitle: 'Политика конфиденциальности',
    eula: 'ЛСДП',
    eulaTitle: 'Лицензионное соглашение с конечным пользователем',
  },
  terms: {
    title: 'Перед игрой',
    intro: 'Пожалуйста, ознакомьтесь и примите оба документа, чтобы продолжить.',
    privacyLabel: 'Я прочитал и принимаю {link}.',
    eulaLabel: 'Я прочитал и принимаю {link}.',
    privacyLink: 'Политику конфиденциальности',
    eulaLink: 'Лицензионное соглашение с конечным пользователем',
    privacyTitle: 'Политика конфиденциальности',
    eulaTitle: 'Лицензионное соглашение с конечным пользователем',
    continue: 'Продолжить',
  },
  character: {
    newTitle: 'Новый персонаж',
    loadTitle: 'Загрузить персонажа',
    nameLabel: 'Имя',
    namePlaceholder: 'Введите имя…',
    create: 'Создать',
    cancel: 'Отмена',
    current: 'Текущий',
    emptySlot: '— Пусто —',
    newSlot: 'Новый',
    deleteLabel: 'Удалить',
    nameTaken: 'Это имя уже занято.',
    infoTitle: 'Персонаж',
    statMaxLife: 'Макс. здоровье',
    statMaxMana: 'Макс. мана',
  },
  settings: {
    title: 'Настройки',
    language: 'Язык',
    languageTitle: 'Язык',
    hotkeysTitle: 'Горячие клавиши',
    langEn: 'English',
    langFr: 'Français',
    langEs: 'Español',
    langZh: '简体中文',
    langRu: 'Русский',
    close: 'Закрыть',
    guide: 'Руководство',
    discord: 'Discord',
    soundVolume: 'Громкость звука',
    soundMuted: 'Отключить звук',
    effectOpacity: 'Непрозрачность эффектов',
    effectDetail: 'Отрисовка эффектов',
    showDamageNumbers: 'Показывать числа урона',
    showDpsMeter: 'Счётчик DPS',
    fullMastery: 'Полное мастерство',
    zoomLabel: 'Масштаб',
    fullscreen: 'Полный экран',
    confirmDeath: 'Подтверждать ручную смерть',
    resetTutorials: 'Сбросить обучение',
    saveData: 'Данные сохранения',
    saveDataDesc: 'Скопируйте код сохранения для резервной копии или переноса на другое устройство, или вставьте код для восстановления. Импорт заменяет всех текущих персонажей.',
    exportSave: 'Скопировать код сохранения',
    exportCopied: 'Скопировано!',
    importLabel: 'Вставить код сохранения',
    importPlaceholder: 'Вставьте код сохранения сюда…',
    importBtn: 'Импортировать',
    importError: 'Недействительный код сохранения',
    importConfirmTitle: 'Заменить всех персонажей?',
    importConfirmBody: 'Импорт навсегда заменит ВСЕХ ваших существующих персонажей данными сохранения. Это действие нельзя отменить.',
    importConfirmBtn: 'Заменить',
    cancel: 'Отмена',
  },
  guide: {
    title: 'Руководство',
    comingSoon: 'Скоро…',
  },
  tutorial: {
    dismiss:  'Закрыть',
    next:     'Далее',
    done:     'Готово',
    moreInfo: 'Подробнее →',
    dontShow: 'Не показывать обучение',
  },
  awayBonus: {
    title:   'С возвращением!',
    body:    'Вы отсутствовали {away} и заработали {earned} времени на скорости ×2.',
    close:   'Закрыть',
    watchAd: 'Смотреть рекламу — удвоить награду',
    continue: 'Продолжить',
  },
  refillAd: {
    title:   'Запас пуст',
    body:    'Ваш запас скорости ×2 только что иссяк. Посмотрите короткую рекламу, чтобы получить 15 минут.',
    watchAd: 'Смотреть рекламу — получить 15 мин',
    skip:    'Нет, спасибо',
    refill:  'пополнить',
  },
  masteryCategory: {
    action: 'Действие',
    damageBase: 'Базовый урон',
    damageType: 'Тип урона',
    lifeMana: 'Жизнь и мана',
    world: 'Мир',
  },
  masteryLabel: {
    action: 'Действие',
    criticalHit: 'Критический удар',
    physical: 'Физический',
    fire: 'Огонь',
    lightning: 'Молния',
    cold: 'Холод',
    rot: 'Гниль',
    area: 'Площадь',
    projectile: 'Снаряд',
    strike: 'Удар',
    life: 'Жизнь',
    mana: 'Мана',
    block: 'Блок',
    enemy: 'Враг',
    movement: 'Движение',
  },
  masteryTree: {
    action_0: 'Урон действия', action_1: 'Скорость действия', action_2: 'Транс', action_3: 'Стоимость маны',
    criticalHit_0: 'Урон крита', criticalHit_1: 'Шанс крита',
    physical_0: 'Физический урон', physical_1: 'Кровотечение', physical_2: 'Пробитие сопротивления', physical_3: 'Жажда крови',
    fire_0: 'Урон огнём', fire_1: 'Горение', fire_2: 'Горящая земля', fire_3: 'Самосожжение',
    lightning_0: 'Урон молнией', lightning_1: 'Электрошок', lightning_2: 'Прыжок', lightning_3: 'Электризация',
    cold_0: 'Урон холодом', cold_1: 'Мороз', cold_2: 'Разрушение', cold_3: 'Ледяной доспех',
    rot_0: 'Урон гнилью', rot_1: 'Яд', rot_2: 'Ослабление', rot_3: 'Зелёные вены',
    area_0: 'Урон по площади', area_1: 'Размер области', area_2: 'Дрожание', area_3: 'Отброс',
    projectile_0: 'Урон снарядом', projectile_1: 'Множество снарядов', projectile_2: 'Дальность снаряда', projectile_3: 'Отброс',
    strike_0: 'Урон от удара', strike_1: 'Ярость', strike_2: 'Дальность удара', strike_3: 'Доп. цель',
    life_0: 'Максимум жизни', life_1: 'Сопротивления', life_2: 'Восстановление жизни', life_3: 'Кража жизни',
    mana_0: 'Максимум маны', mana_1: 'Щит маны', mana_2: 'Восстановление маны', mana_3: 'Кража маны',
    block_0: 'Шанс блока', block_1: 'Эффективность блока',
    enemy_0: 'Кол-во врагов', enemy_1: 'Качество врагов', enemy_2: 'Чемпионы и боссы', enemy_3: 'Размножение врагов',
    movement_0: 'Скорость движения', movement_1: 'Рывок', movement_2: 'Кайтинг',
  },
  masteryDump: {
    action: 'урона действия', criticalHit: 'урона крита', physical: 'физического урона',
    fire: 'урона огнём', lightning: 'урона молнией', cold: 'урона холодом', rot: 'урона гнилью', area: 'радиуса действия',
    projectile: 'дальности снаряда', strike: 'скорости удара', life: 'максимума жизни',
    mana: 'максимума маны', enemy: 'призываемых врагов', movement: 'скорости движения',
    block: 'шанс блока',
  },
  runeLabel: {
    minorDmg: 'Урон', minorSpeed: 'Скорость', minorMana: 'Мана', minorXp: 'Опыт', minorAll: 'Смешанная',
    majorDmg: 'Урон', majorSpeed: 'Скорость', majorMana: 'Мана', majorXp: 'Опыт', majorAll: 'Смешанная',
    keySplit: 'Разделение', keyHeavy: 'Медленно и тяжело', keyManaless: 'Без маны', keyConsequences: 'Последствия',
    sourceCold: 'Открытый холодильник', sourceFire: 'Включённая плита', sourceLightning: 'Включённая ловушка для насекомых', sourcePhysical: 'Рассыпанные гвозди', sourceRot: 'Разбросанные носки',
  },
  runeDesc: {
    minorDmg: '+15% к увеличению урона действия',
    minorSpeed: '+5% к увеличению скорости действия',
    minorMana: '−10% к стоимости маны действия',
    minorXp: '+20% к увеличению опыта действия',
    minorAll: '+3,75% урон / +1,25% скорость / −2,5% стоимость маны / +5% опыт',
    majorDmg: '10% больше урона действия',
    majorSpeed: '5% больше скорости действия',
    majorMana: '20% меньше стоимость маны действия',
    majorXp: '15% больше опыта действия',
    majorAll: '2,5% больше урона / 1,25% больше скорости / 5% меньше маны / 3,75% больше опыта',
    keySplit: '×2 скорость действия — на 33% меньше урона действия',
    keyHeavy: '×2 урон действия — на 33% меньше скорости действия',
    keyManaless: '×2 стоимость маны — действие выполняется даже при нехватке маны',
    keyConsequences: '×2 урон недугов от этого действия (не влияет на недуги без урона)',
    sourceCold: '20% ударов считаются холодом вместо источника действия — применяются эффекты и опыт мастерства холода',
    sourceFire: '20% ударов считаются огнём вместо источника действия — применяются эффекты и опыт мастерства огня',
    sourceLightning: '20% ударов считаются молнией вместо источника действия — применяются эффекты и опыт мастерства молнии',
    sourcePhysical: '20% ударов считаются физическими вместо источника действия — применяются эффекты и опыт физического мастерства',
    sourceRot: '20% ударов считаются гнилью вместо источника действия — применяются эффекты и опыт мастерства гнили',
  },
  actionLabel: {
    sword: 'Удар мечом', bow: 'Снайперская стрела', fireball: 'Огненный шар', zap: 'Молния',
    'fire-nova': 'Огненная волна', grenade: 'Граната', 'hammer-slam': 'Удар молотом',
    'lightning-nova': 'Молниевая волна', bolt: 'Болт', 'cold-nova': 'Ледяная волна', 'ice-spear': 'Ледяное копьё',
    'putrid-nova': 'Гнилостная волна',
    'rotten-dagger': 'Гнилой кинжал',
    'poisonous-arrow': 'Ядовитая стрела',
  },
  actionTag: {
    physical: 'физический', fire: 'огонь', lightning: 'молния', cold: 'холод', rot: 'гниль',
    strike: 'удар', projectile: 'снаряд', area: 'область',
  },
}
